import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-navi-list-link-on-admin" }
const _hoisted_2 = {
  key: 0,
  class: "p-navi-list-link-on-admin__link__icon"
}
const _hoisted_3 = { class: "p-navi-list-link-on-admin__link__body" }
const _hoisted_4 = {
  key: 0,
  class: "p-navi-list-link-on-admin__link__notification"
}
const _hoisted_5 = {
  key: 1,
  ref: "arrowElement",
  class: "p-navi-list-link-on-admin__link__arrow"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextLabelNewArrivalCount = _resolveComponent("TextLabelNewArrivalCount")!
  const _component_IconArrowBottom = _resolveComponent("IconArrowBottom")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.url === '' ? 'button' : 'a'), {
      href: _ctx.url === '' ? undefined : _ctx.url,
      class: "p-navi-list-link-on-admin__link",
      onMouseover: _ctx.emitMouseover,
      onMouseleave: _ctx.emitMouseleave,
      onClick: _ctx.emitClick
    }, {
      default: _withCtx(() => [
        (_ctx.$slots.icon)
          ? (_openBlock(), _createElementBlock("i", _hoisted_2, [
              _renderSlot(_ctx.$slots, "icon", {}, undefined, true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_3, [
          _createElementVNode("span", {
            class: "p-navi-list-link-on-admin__link__text",
            style: _normalizeStyle({ color: _ctx.hoverColor.currentHover })
          }, [
            _renderSlot(_ctx.$slots, "label", {}, undefined, true)
          ], 4),
          (_ctx.notificationCount && _ctx.hasNotification)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _createVNode(_component_TextLabelNewArrivalCount, { count: _ctx.notificationCount }, null, 8, ["count"])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.childList)
          ? (_openBlock(), _createElementBlock("i", _hoisted_5, [
              _createVNode(_component_IconBase, {
                width: 24,
                height: 24,
                "view-box": "0 0 24 24",
                "icon-color": "#3c3c3c"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconArrowBottom)
                ]),
                _: 1
              })
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 40, ["href", "onMouseover", "onMouseleave", "onClick"])), [
      [_directive_touch, void 0, "tap"]
    ]),
    _renderSlot(_ctx.$slots, "content", {}, undefined, true)
  ]))
}